/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const getDefaultState = () => ({
  rating: 3,
  comment: '',
  actualStep: 1,
  nbStep: 3,
  feedbackSent: false,
  progressBarHidden: false,
  checkboxArchive: true,
});
// initial state
const state = getDefaultState();

// getters
const getters = {
  getRating: (state) => state.rating,
  actualStep: (state) => state.actualStep,
  nbStep: (state) => state.nbStep,
  getComment: (state) => state.comment,
  getFeedbackSent: (state) => state.feedbackSent,
  getProgressBarHidden: (state) => state.progressBarHidden,
  getCheckboxArchive: (state) => state.checkboxArchive,
};

// actions
const actions = {
  RESET_VALUE({ commit }) {
    commit('RESET_VALUE');
  },
  CHANGE_ACTUAL_STEP({ commit }, step) {
    commit('SET_ACTUAL_STEP', step);
  },
  UPDATE_RATING({ commit }, rating) {
    commit('SET_RATING', rating);
  },
  UPDATE_COMMENT({ commit }, comment) {
    commit('SET_COMMENT', comment);
  },
  CHANGE_NB_STEP({ commit }, nbStep) {
    commit('SET_NB_STEP', nbStep);
  },
  UPDATE_FEEDBACK_SENT({ commit }, value) {
    commit('SET_FEEDBACK_SENT', value);
  },
  UPDATE_PROGRESS_BAR_HIDDEN({ commit }, value) {
    commit('SET_PROGRESS_BAR_HIDDEN', value);
  },
  UPDATE_CHECKBOX_ARCHIVE({ commit }, value) {
    commit('SET_CHECKBOX_ARCHIVE', value);
  },
};

// mutations
const mutations = {
  SET_RATING(state, rating) {
    state.rating = rating;
  },
  SET_ACTUAL_STEP(state, step) {
    state.actualStep = step;
  },
  SET_NB_STEP(state, nbStep) {
    state.nbStep = nbStep;
  },
  SET_COMMENT(state, comment) {
    state.comment = comment;
  },
  SET_FEEDBACK_SENT(state, feedbackSent) {
    state.feedbackSent = feedbackSent;
  },
  SET_PROGRESS_BAR_HIDDEN(state, progressBarHidden) {
    state.progressBarHidden = progressBarHidden;
  },
  SET_CHECKBOX_ARCHIVE(state, checkboxArchive) {
    state.checkboxArchive = checkboxArchive;
  },
  RESET_VALUE(state) {
    Object.assign(state, getDefaultState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
